import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';
import { achievementsApi } from '../api/achievements';

export function useAchievements() {
  return useQuery({
    queryKey: queryKeys.achievements.list(),
    queryFn: async () => {
      const { data } = await achievementsApi.list();
      return data;
    },
    staleTime: 60_000,
  });
}
